import React from 'react';
import { View } from 'react-native';
import { KidCarousel } from '@kid-ui/krn';
import assetsMap from './uri.json';
import { onShowGuaranteeV1 } from '@/page/detail/views/jump';
import { lang } from '@/common/const';
import { scaleW, pxToRem } from '@/common/style';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { logger } from '@/common/log';
import { afterPv } from '@/common/utils/afterPv';
import { useFirstScreenAB } from '../abTest/firstScreen/useFirstScreenAb';
import { KImage } from '@/component/RtlLayout';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';

type CarouselConfig = {
    carouselHeight?: number;
    // 轮播高度
    carouselWidth?: number;
    // 轮播宽度
    loop?: boolean;
    // 是否循环轮播
    autoplay?: boolean;
    // 是否自动播放
    autoplayTimeout?: number;
    // 设置自动播放时间
    horizontal?: boolean;
    // 设置 carousel 为水平模式，值为 false 时竖直模式
    showsPagination?: boolean;
    // 是否展示指示器
    borderRadius?: number;
    // 设置 carousel 的圆角
    itemId?: number;
    // onShowGuaranteeV1需传入
    openMask?: boolean;
    // 是否跳转到服务保障详细页
    index?: number;
    // 是否用配置的 URL 代替保障图
    url?: string;
    // resizeMode
    resizeMode?: 'cover' | 'contain' | 'center' | 'repeat' | 'stretch';
};

const carouselBaseConfig: CarouselConfig = {
    carouselHeight: pxToRem(36),
    carouselWidth: pxToRem(414),
    loop: true,
    autoplay: true,
    autoplayTimeout: 2,
    horizontal: false,
    showsPagination: false,
    borderRadius: 0,
    openMask: false,
    itemId: 0,
};

const carouselLangType = (type: String) => (lang === 'pt-BR' ? type + '_PORTUGUESE' : type + '_ENGLISH');
const lineMap = {
    DETAIL: 'link',
    LIVE: 'link',
    ORDER: 'link',
};
const baseKey = ['ORDER', 'NEW'];

const useShowGuarantee = ({
    type = 'DETAIL',
    carouselConfig = {},
    style = {},
    snedClickLog,
    sendShowLog,
}: {
    type?: any;
    carouselConfig?: CarouselConfig;
    style?: any;
    snedClickLog?: () => void;
    sendShowLog?: () => void;
}) => {
    const isBaseKey = baseKey.some(item => item === type);

    const guaranteeStatus = {
        ifServiceGuarantee: true,
        serviceGuaranteeStyle: 2,
        guaranteeAssets: isBaseKey ? assetsMap[carouselLangType(type)] : assetsMap[carouselLangType(type) + '_TWO'] || [],
        status: true,
    };

    //type为需展示轮播的页面，例如'DETAIL', 'LIVE' style为轮播图样式
    const GuaranteeSwiper = () => {
        // 合并传入
        const mergeConfig = { ...carouselBaseConfig, ...carouselConfig };

        const onPressAble = () => {
            if (mergeConfig.openMask) {
                onShowGuaranteeV1(0);
                snedClickLog ? snedClickLog?.() : afterPv.then(() => logger.sendClick({ action: 'REST_ASSURED_PURCHASE_BAR', params: { type: 0 } }));
            }
        };

        return (
            <View>
                <KTouchableOpacity activeOpacity={1} onPress={onPressAble}>
                    <ViewVisible
                        onVisible={() => {
                            sendShowLog
                                ? sendShowLog?.()
                                : afterPv.then(() =>
                                      logger.sendShow({
                                          action: 'REST_ASSURED_PURCHASE_BAR',
                                          params: { type: 0 },
                                      })
                                  );
                        }}>
                        {mergeConfig?.url ? (
                            <KImage
                                style={[{ width: pxToRem(414), height: pxToRem(36) }, style]}
                                resizeMode={mergeConfig?.resizeMode || 'cover'}
                                source={{ uri: mergeConfig.url }}
                            />
                        ) : (
                            <KidCarousel {...mergeConfig}>
                                {guaranteeStatus.guaranteeAssets.map(imgUri => {
                                    return (
                                        <KImage
                                            source={{ uri: imgUri }}
                                            resizeMode={mergeConfig?.resizeMode || 'cover'}
                                            style={[{ width: pxToRem(414), height: pxToRem(36) }, style]}
                                        />
                                    );
                                })}
                            </KidCarousel>
                        )}
                    </ViewVisible>
                </KTouchableOpacity>
            </View>
        );
    };

    return {
        GuaranteeSwiper,
        guaranteeStatus: guaranteeStatus.status,
    };
};

export default useShowGuarantee;
